import Chip from "../Chip";
import { useTranslate } from "../../hooks/useTranslate";

const VerificationStatusChip = (props) => {
    const { status } = props;

    const { t } = useTranslate();

    return (
        <Chip
            isSuccess={status.isSuccess}
            isWarning={status.isWarning}
            isInfo={status.isInfo}
            isError={status.isError}
        >
            {t(status.statusTextKey)}
        </Chip>
    );
};

export default VerificationStatusChip;
